const getDefaultState = () => ({
  productTypes: {
    loading: false,
    items: [],
  },
  overview: {
    loading: false,
    error: false,
    items: [],
  },
  create: {
    loading: false,
    error: false,
  },
  edit: {
    loading: false,
    error: false,
    item: null,
  },
  countries: {
    loading: false,
    error: false,
    items: [],
  },
  masterCountries: {
    loading: false,
    error: false,
    items: [],
  },
  salesCountries: {
    loading: false,
    error: false,
    items: [],
  },
  tripThemes: {
    loading: false,
    error: false,
    items: [],
  },
  assignedTripThemes: {
    loading: false,
    error: false,
    items: [],
  },
  dayProgram: {
    loading: false,
    error: false,
    items: [],
  },
  dayProgramLocation: {
    dayProgram: null,
    loading: false,
  },
  dayProgramHotel: {
    loading: false,
    dayProgram: null,
    hotelsByArea: [],
    selectedHotels: [],
  },
  dayProgramExtras: {
    loading: false,
    dayProgram: null,
    extras: [],
    config: null,
  },
  dayProgramMealPlans: {
    loading: false,
    dayProgram: null,
    error: false,
    mealPlans: [],
  },
  mealPlanTypes: {
    loading: false,
    error: false,
    types: [],
    options: [],
  },
  domains: {
    loading: false,
    error: false,
    selected: null,
    items: [],
  },
  dayProgramImages: {
    loading: false,
    error: false,
    items: [],
  },
  seoTeasers: {
    loading: false,
    error: false,
    items: [],
  },
  includes: {
    loading: false,
    error: false,
    items: [],
  },
  includeCategories: {
    loading: false,
    error: false,
    items: [],
  },
  bannerImages: {
    loading: false,
    error: false,
    items: [],
  },
  mapImages: {
    loading: false,
    error: false,
    items: [],
  },
  pricesDayProgram: {
    loading: false,
    error: false,
    items: [],
  },
  priceIntervals: {
    loading: false,
    syncing: false,
    error: false,
    items: null,
  },
  itinerary: {
    loading: false,
    error: false,
  },
  matrixAges: {
    loading: false,
    error: false,
    items: [],
  },
  matrixPrices: {
    loading: false,
    error: false,
    items: [],
  },
  calculatedMatrixPrices: {
    loading: false,
    error: false,
    items: [],
  },
  settingAllPrices: {
    loading: false,
  },
  saveMatrixPrices: {
    loading: false,
    error: false,
  },
  itineraryTexts: {
    loading: false,
    error: false,
    items: [],
  },
  carSuppliers: {
    loading: false,
    error: false,
    items: [],
  },
  carSheets: {
    loading: false,
    error: false,
    items: [],
  },
  carGroups: {
    loading: false,
    error: false,
    items: [],
  },
  carRentals: {
    loading: false,
    error: false,
    items: [],
  },

  // Price settings
  priceSettings: {
    loading: false,
    syncing: false,
    error: false,
    items: null,
  },
  selectedPriceIntervalIndex: 0,
  ageDiscounts: [],
  groupPaxes: [],
  poster: {
    loading: false,
    error: false,
    item: null,
  },
  posterImages: {
    loading: false,
    error: false,
    items: null,
  },
  selectedExtraCategory: null,
  itinerarySuppliers: {
    loading: false,
    error: false,
    items: [],
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/itinerary/defaultState.js